module.exports = __webpack_public_path__ + "static/media/LatrineNeptune.1309f0dc.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/LatrineNeptune.JPG
// module id = 669
// module chunks = 0